import type { ServiceCode } from '../../../../common/enums/serviceCode';
import type { IProcedureGetOne } from '../../interfaces/procedureGetOne';
import { ToastType } from '../../../../common/enums/toastType';
import { fetchJson } from '../../../store/fetch';
import { translateKey } from '../../../translate';
import { showServiceToast } from '../../../utils/showToast';
import { Button } from '../common';
import { Component } from '../Component';
import { ConfirmationModal } from '../modals/ConfirmationModal';

interface IRemoveProcedureButtonProps {
    procedure: IProcedureGetOne;
    removeProcedure?: () => Promise<void>;
    serviceCode: ServiceCode;
}

export class RemoveProcedureButton extends Component<IRemoveProcedureButtonProps, { showModal?: boolean }> {
    public render() {
        if (
            !this.props.procedure.authorization ||
            !this.props.procedure.authorization.canDelete ||
            !this.props.removeProcedure
        ) {
            return null;
        }

        return (
            <>
                <ConfirmationModal
                    handleNo={async () => await this.setState({ showModal: false })}
                    handleYes={async () => {
                        const url = `/api/procedures/${this.props.procedure.id}`;
                        await fetchJson(url, 'DELETE');
                        showServiceToast(
                            ToastType.info,
                            'toast.cancelSuccess',
                            { code: this.props.serviceCode },
                            'procedure',
                            translateKey('toast.cancelDefaultMessage')
                        );

                        await this.props.removeProcedure!();
                    }}
                    isOpen={this.state.showModal || false}
                    question={translateKey('request.confirmCancelRequest')}
                    title={translateKey('common.notice')}
                />

                <Button
                    automation="removeProcedure"
                    color="secondary"
                    large
                    onClick={async () => await this.setState({ showModal: true })}
                    outlined
                >
                    {translateKey('request.statusAction_cancelled')}
                </Button>
            </>
        );
    }
}
